import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src431700410/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Additional Terms for .SUCKS Registrations and Blocks</h1>
    <p>
  .SUCKS domain registrations and blocks are subject to{' '}
  <a href="https://www.nic.sucks/policies">
    Vox Populi Registry's policies, terms, and conditions
  </a>
  .
    </p>
    <p>These policies include:</p>
    <ul>
  <li>
    <a href="https://www.nic.sucks/docs/policies/Acceptable%20Use%20Policy%20and%20Terms%20of%20Service%20v1.0.pdf">
      Acceptable Use Policy and Terms of Service
    </a>
  </li>
  <li>
    <a href="https://www.nic.sucks/docs/policies/VoxPop%20-%20Registration%20Terms%20and%20Conditions%20v1.0.pdf">
      Registration Terms and Conditions
    </a>
  </li>
  <li>
    <a href="https://www.nic.sucks/docs/policies/VoxPop%20Domain%20Block%20Terms%20and%20Conditions%20v1.1.pdf">
      Domain Block Terms &amp; Conditions
    </a>
  </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      